
export const GET_RESET = "reset";
export const GET_BANNERS = "getBanners"

